declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';




@Component({
    selector: 'auto-section-1',
    templateUrl: './autosection1.component.html',
    styleUrls: ['./autosection1.component.scss']
})

export class AutoSection1Component implements OnInit {
    ngOnInit(): void {
       
    }
}
